import { Box, Typography, useTheme } from '@mui/material';
import { useIntl } from 'react-intl';

import { useSupervisorProjectOverview } from './useSupervisorProjectOverview';
import { PeopleSection } from '../../../admin-common/components/PeopleSection';
import { AllocationSummaryTable } from '../../../admin-projects/components/ProjectOverviewContent/AllocationSummaryTable';
import { DatasetSummary } from '../../../admin-projects/components/ProjectOverviewContent/DatasetSummary';
import { ProjectBasics } from '../../../admin-projects/components/ProjectOverviewContent/ProjectBasics';
import { ReviewConceptAndAttributes } from '../../../admin-projects/components/ProjectOverviewContent/ReviewConceptAndAttributes';
import type { AllocationSummary, Concept } from '../../../admin-projects/types/response';

export const SupervisorProjectOverview = () => {
  const theme = useTheme();
  const { formatMessage } = useIntl();
  const {
    projectName,
    conditionAreaName,
    healthSystemName,
    annotatorNames,
    supervisorNames,
    addedConcepts,
    validationEncounterCount,
    testEncounterCount,
    trainingEncounterCount,
    allocationSummary,
    isDataLoading,
  } = useSupervisorProjectOverview();

  return (
    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: theme.spacing(4) }}>
      <Box>
        <Typography variant="h5">
          {formatMessage({ id: 'adminProjects.projectOverview.title' })}
        </Typography>
      </Box>
      <Box>
        <ProjectBasics
          projectName={projectName}
          conditionAreaName={conditionAreaName}
          healthSystemName={healthSystemName}
        />
      </Box>
      <Box>
        <PeopleSection
          annotatorNames={annotatorNames}
          supervisorNames={supervisorNames}
          isLoading={isDataLoading}
        />
      </Box>
      <Box sx={{ display: 'flex', gap: theme.spacing(2) }}>
        <Box sx={{ flexGrow: 1 }}>
          <ReviewConceptAndAttributes
            addedConcepts={addedConcepts as Concept[]}
            isLoading={isDataLoading}
          />
        </Box>
        <Box
          id="review-sidebar"
          sx={{
            width: '450px',
            p: theme.spacing(4),
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(4),
          }}
        >
          <DatasetSummary
            validationEncounterCount={validationEncounterCount}
            testEncounterCount={testEncounterCount}
            trainingEncounterCount={trainingEncounterCount}
            isLoading={isDataLoading}
          />
          <AllocationSummaryTable
            allocationSummary={allocationSummary as AllocationSummary[]}
            isLoading={isDataLoading}
          />
        </Box>
      </Box>
    </Box>
  );
};
